import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultEventUser: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.default-event-user',
		defaultMessage: 'Rules will run as if performed by the following user:',
		description: '',
	},
	userSelectPlaceHolder: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.user-select-place-holder',
		defaultMessage: 'Select default event user',
		description: '',
	},
	intro: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.intro',
		defaultMessage:
			'You can make an exception to this default user in the set-up of individual rules.',
		description: '',
	},
	thisUserShould: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.this-user-should',
		defaultMessage: "The rules won't run as you intend unless the user you've chosen:",
		description: '',
	},
	explanationItem1Jsm: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.explanation-item-1-jsm',
		defaultMessage: 'can view issues in this service project',
		description: '',
	},
	explanationItem2: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.explanation-item-2',
		defaultMessage: 'has permission to perform the actions in this rule',
		description: '',
	},
	noPermission: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.no-permission',
		defaultMessage: 'The selected user does not have permission to perform this action.',
		description: '',
	},
	userDeleted: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.user-deleted',
		defaultMessage: 'The selected user has been deleted.',
		description: '',
	},
	chooseAnotherUser: {
		id: 'servicedesk.automation.summary.header.settings-dialog.content.user-picker.choose-another-user',
		defaultMessage: 'Please choose another user',
		description: '',
	},
});
